import React, { Fragment } from "react";
import { useIntl } from 'react-intl';

import SEO from "@components/seo";
import Controls from "@components/Controls/controls";
import UniplacesFullContainer from "@components/UniplacesFullContainer/uniplacesFullContainer";
import HeroSection from "@components/HeroSection/heroSection";
import PartnersList from "@components/partnersPage/PartnersList/partnersList";
import PartnersCta from "@components/partnersPage/PartnersCta/partnersCta";

const heroImage = {
  url: `${process.env.CDN_URL}/images/accommodation-hero-image.png`,
  alt: 'Partners Hero Image'
};

const PartnersTemplate = ({ pageContext: { locale } }) => {
  const intl = useIntl();

  return (
    <Fragment>
      <SEO
        titleKey="Partners"
        descriptionKey="Companies and Universities that partner with Uniplaces"
        imageUrl={heroImage.url}
        lang={locale}
      />
      <HeroSection
        heroHeading={intl.formatMessage({ id: 'Partners' })}
        heroSubheading={intl.formatMessage({ id: 'Meet our partners' })}
        heroImage={heroImage}
      />
      <UniplacesFullContainer>
        <React.Fragment>
          <PartnersList />
          <PartnersCta
            ctaTitle={intl.formatMessage({ id: 'Looking to join as a partner?' })}
            ctaText={intl.formatMessage({ id: 'Contact us' })}
            ctaLink={'mailto:partnerships@uniplaces.com'}
          />
          <Controls />
        </React.Fragment>
      </UniplacesFullContainer>
    </Fragment>
  );
};

export default PartnersTemplate;
